// components
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';
import { styled } from '@mui/material';

export const StyledSnackbar = styled(Snackbar)<SnackbarProps>(() => ({
  width: 'max-content',
  margin: 'auto'
}));
